import { Component, OnInit } from "@angular/core";
import { NbIconLibraries, NbThemeService } from "@nebular/theme";
@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  constructor(
    private iconLibraries: NbIconLibraries,
    private themeService: NbThemeService
  ) {
    this.iconLibraries.registerFontPack("font-awesome", {
      packClass: "fas",
      iconClassPrefix: "fa",
    });
    this.iconLibraries.setDefaultPack("font-awesome"); // <---- set as default
  }

  ngOnInit(): void {
    if (localStorage.getItem("theme"))
      this.themeService.changeTheme(localStorage.getItem("theme"));
  }
}
